import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager';
import { CurrencyType } from '../../vendor_core/core/src/managers/contracts/configurations/IBetConfig';
import ILocalConfig from '../../vendor_core/core/src/managers/contracts/configurations/ILocalConfig';
import BetModel from '../../vendor_core/core/src/model/BetModel';
import { version, name } from "../../package.json";
import CurrencyUtils from '../../vendor_core/core/src/utils/CurrencyUtils';
import JackpotsModel from '../../vendor_core/src/model/JackpotsModel';
import RealityCheckModel from '../../vendor_core/core/src/model/RealityCheckModel';
import App from '../../vendor_core/core/src/App';
import Configs from '../../vendor_core/src/vendorConfigs/Configs';
import BuyFeatureModel from '../../vendor_core/core/src/model/BuyFeatureModel';
import DoubleChanceConfig from './DoubleChanceConfig';
import GameModel from '../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../vendor_core/core/src/model/SpinModel';

class VendorLocalConfig implements ILocalConfig {
    type: ConfigurationTypes = ConfigurationTypes.LOCAL;
    overwritePatterns: { overwriteString: string; pattern: () => string; }[] = [
        {
            overwriteString: "{MAX_BET}",
            pattern: () => {
                const maxBet = BetModel.creditValues[BetModel.creditValues.length - 1] / 100;
                const locale = BetModel.currencyLocalization;
                return CurrencyUtils.formatCurrency(maxBet, locale);
            }
        },
        {
            overwriteString: "{RTP}",
            pattern: () => Configs.game?.getRTP().toFixed(2) || ""
        },
        {
            overwriteString: "{WIN_CAP}",
            pattern: () => {return "10 000"}
        },
        {
            overwriteString: "{RTPBuy}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature?.buyFeatureRtp[BuyFeatureModel.mode].toFixed(2) || "";
                } else {
                    return "{RTPBuy}";
                }
            }
        },
        {
            overwriteString: "{PriceBuy}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return Configs.buyFeature?.betMultiplier[BuyFeatureModel.mode].toString() || "";
                } else {
                    return "{PriceBuy}";
                }
            }
        },
        {
            overwriteString: "{scatterBoostRTP}",
            pattern: () => {
                if (ConfigManager.hasConfig(ConfigurationTypes.BUY_FEATURE)) {
                    return DoubleChanceConfig?.scatterBoostRtp?.toFixed(2);
                } else {
                    return "{scatterBoostRTP}";
                }
            }
        },
        {
            overwriteString: "{game_version}",
            pattern: () => version
        },
        {
            overwriteString: "{GAMENAME}",
            pattern: () => name
        },
        {
            overwriteString: "{game_datestamp}",
            pattern: () => App.config.versionDate || ""
        },
        {
            overwriteString: "jackpot_fee",
            pattern: () => {
                if (Configs.bet?.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(JackpotsModel.jackpotFee, BetModel.currencyLocalization, true);
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }
            }
        },
        {
            overwriteString: "{playTime}",
            pattern: () => {
                const elapsedTime = RealityCheckModel.milliSecToMin(
                    RealityCheckModel.getElapsedTime()
                );
                //return elapsedTime.min.toString();
                return RealityCheckModel.totalSessionMinutes.toString();
            }

        },
        {
            overwriteString: "{betAmount}",
            pattern: () => {
                if (Configs.bet?.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(
                        (RealityCheckModel.totalBet / App.config.subUnits),
                        BetModel.currencyLocalization
                    ).toString()
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }
            }

        },
        {
            overwriteString: "{winAmount}",
            pattern: () => {
                if (Configs.bet?.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(
                        (RealityCheckModel.totalWin / App.config.subUnits),
                        BetModel.currencyLocalization
                    ).toString()
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }

            }

        },
        {
            overwriteString: "{result}",
            pattern: () => {
                if (Configs.bet?.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(
                        (RealityCheckModel.sessionMoneyResult / App.config.subUnits),
                        BetModel.currencyLocalization
                    ).toString()
                } else {
                    return JackpotsModel.jackpotFee + " coins";
                }

            }
        },
        {
            overwriteString: "progressive_jackpot_pool_reset_value",
            pattern: () => {
                const jackpotResetValue = 10000;
                if (Configs.bet?.primaryCurrencyType == CurrencyType.Money) {
                    return CurrencyUtils.formatCurrency(jackpotResetValue, BetModel.currencyLocalization, true);
                } else {
                    return jackpotResetValue + " coins";
                }
            }
        }
    ];

}

export default new VendorLocalConfig()
